import { GetPageByRouteQuery } from "@eurodrive/apollo"
import { extractProperty } from "./extractProperty"
import { getNonUmbracoUrl } from "./getNonUmbracoUrl"

type Parent = {
  url: string | null | undefined
  id: number | null | undefined
  level: number | null | undefined
  name?: string | null
  parent: Parent
}

export type Breadcrumbs = {
  url: string
  title: string
}[]

function extractTitle(data: any) {
  const node = data
  const pageBlock = extractProperty(data, "pageInfoAndMetaTags")
  if (pageBlock) {
    data = pageBlock?.[0]
  }
  // CMS titleBreadcrumbs is often left empty — fall back to metaTitle,
  // then the content node name, so crumbs never render blank
  const title =
    (extractProperty(data, "titleBreadcrumbs") as string | undefined) ||
    (extractProperty(data, "metaTitle") as string | undefined) ||
    (node?.name as string | undefined)
  return title
}

// Container nodes with no routable page — must never appear as crumb links.
// Relevant now that empty titles fall back to the node name instead of
// silently dropping the parent.
const ignoreUrls: string[] = ["/brands", "/branches/branches"]

export function getBreadCrumbs(data: GetPageByRouteQuery, locale: string) {
  const self = extractTitle(data.page)
  const selfObject: { url: string; title: string } = {
    title: self || "",
    url: getNonUmbracoUrl(data.page?.url || ""),
  }
  const parent = data.page?.parent as Parent
  const parents: Array<{ url: string; title: string }> = []
  function recurse(currentParent: Parent | null) {
    if (
      currentParent &&
      currentParent.level !== null &&
      currentParent.level !== undefined &&
      currentParent.level >= 3
    ) {
      const parentTitle = extractTitle(currentParent)
      const parentUrl = getNonUmbracoUrl(currentParent.url || "")
      if (parentTitle && !ignoreUrls.includes(parentUrl)) {
        parents.push({
          url: parentUrl,
          title: parentTitle,
        })
      }
      if (currentParent.parent) {
        recurse(currentParent.parent)
      }
    }
  }
  recurse(parent ?? null)
  return {
    selfObject,
    parents: [
      {
        title:
          {
            he: "ראשי",
            ar: "الرئيسية",
            ru: "Главная",
            en: "Home page",
          }[locale] || "ראשי",
        url:
          {
            he: "/",
            ar: "/ar",
            ru: "/ru",
            en: "/en",
          }[locale] || "/",
      },
      ...parents.reverse(),
    ],
  }
}

export type BreadCrumbs = {
  selfObject: { url: string; title: string }
  parents: Array<{ url: string; title: string }>
}
